import React from 'react';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';


export const categories = [
  { name: 'New', icon: <HomeIcon />, },
  { name: 'Coding', icon: <CodeIcon />, },
  { name: 'ReactJS', icon: <CodeIcon />, },
  { name: 'NextJS', icon: <CodeIcon />, },
  { name: 'Music', icon: <MusicNoteIcon /> },
  { name: 'Education', icon: <SchoolIcon />, },
  { name: 'Podcast', icon: <GraphicEqIcon />, },
  { name: 'Movie', icon: <OndemandVideoIcon />, },
  { name: 'Gaming', icon: <SportsEsportsIcon />, },
  { name: 'Live', icon: <LiveTvIcon />, },
  { name: 'Sport', icon: <FitnessCenterIcon />, },
  { name: 'Fashion', icon: <CheckroomIcon />, },
  { name: 'Beauty', icon: <FaceRetouchingNaturalIcon />, },
  { name: 'Comedy', icon: <TheaterComedyIcon />, },
  { name: 'Gym', icon: <FitnessCenterIcon />, },
  { name: 'Crypto', icon: <DeveloperModeIcon />, },
];

export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'JavaScript Mastery';
export const demoVideoTitle = 'Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png'


export const videoData=[
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "PCUynbQ45Bo"
      },
      "snippet": {
        "publishedAt": "2022-09-10T02:05:54Z",
        "channelId": "UCYNyi6I73JdRRhs9UmSTFxg",
        "title": "Worship at Home – 3 PESAN KEHIDUPAN • September 9th, 2022 | Robert Lea Sutanto",
        "description": "Welcome to Worship at Home with Robert & Lea Sutanto! \"3 PESAN KEHIDUPAN\" Worship at Home with Robert & Lea Sutanto ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/PCUynbQ45Bo/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/PCUynbQ45Bo/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/PCUynbQ45Bo/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Robert & Lea Sutanto",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-10T02:05:54Z",
      },
      "statistics":{
        "viewCount":245,
        "likeCount":12
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "5Nk8xlM28B4"
      },
      "snippet": {
        "publishedAt": "2022-09-10T01:00:09Z",
        "channelId": "UCsLF0qPTpkYKq81HsjgzhwQ",
        "title": "15 MIN TOTAL CORE + ABS Workout - No Equipment, No Repeat, Home Workout to strengthen your core",
        "description": "Team, are you ready to WORK? 15 minutes - YOU CAN DO IT! Let's strengthen and tone our CORE + ABS! A quick & effective ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/5Nk8xlM28B4/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/5Nk8xlM28B4/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/5Nk8xlM28B4/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "growingannanas",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-10T01:00:09Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "eHN2JKBq9qM"
      },
      "snippet": {
        "publishedAt": "2022-09-09T23:16:29Z",
        "channelId": "UC6BuFqsjfeC8WbbQkud-iKQ",
        "title": "Best game play at home, Funny family play games - Felix Play #Shorts #comedy",
        "description": "Welcome to Felix Play channel Thank for your support!!",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/eHN2JKBq9qM/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/eHN2JKBq9qM/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/eHN2JKBq9qM/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Felix Play 龙龙·🍭🍭",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T23:16:29Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "rK6mvlFmZzk"
      },
      "snippet": {
        "publishedAt": "2022-09-09T22:24:33Z",
        "channelId": "UCoqlgDBpk_BgU0546zytj4A",
        "title": "Spider Man Far From Home vs Spider Man No Way Home Funny Cartoon Animations",
        "description": "Spider Man Far From Home vs Spider Man No Way Home Funny Cartoon Animations.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/rK6mvlFmZzk/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/rK6mvlFmZzk/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/rK6mvlFmZzk/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Prenses Buğlem 1",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T22:24:33Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "cvMhVSV_tnM"
      },
      "snippet": {
        "publishedAt": "2022-09-09T22:00:16Z",
        "channelId": "UCS9dTkpL6pPj2nrYjsjnb3A",
        "title": "Abraham Lincoln&#39;s Home in Springfield, Illinois",
        "description": "We stopped for a couple nights in Springfield, Illinois so that we could visit the home of Abraham Lincoln and finish out our tour of ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/cvMhVSV_tnM/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/cvMhVSV_tnM/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/cvMhVSV_tnM/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Abom Adventures",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T22:00:16Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "FpW2kWia6zY"
      },
      "snippet": {
        "publishedAt": "2022-09-09T20:16:50Z",
        "channelId": "UCOuY0U8zJAyK8eJ35_Mo8kg",
        "title": "Home",
        "description": "Provided to YouTube by DistroKid Home · Ryan Dwyer Apparition ℗ Red Trail Swamp Released on: 2016-11-06 Auto-generated ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/FpW2kWia6zY/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/FpW2kWia6zY/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/FpW2kWia6zY/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Ryan Dwyer - Topic",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T20:16:50Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "SwerBbvutlI"
      },
      "snippet": {
        "publishedAt": "2022-09-09T19:45:01Z",
        "channelId": "UCidJftClM4kU1196YynvqXg",
        "title": "DIY Shed Converted into Micro Tiny House",
        "description": "Tiny Living Course - All Things Tiny - https://bit.ly/thtcourse4 Subscribe For Weekly Newsletter : https://bit.ly/THT-Newsletter Tiny ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/SwerBbvutlI/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/SwerBbvutlI/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/SwerBbvutlI/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Tiny Home Tours",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T19:45:01Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "Xp1rzNbPUK8"
      },
      "snippet": {
        "publishedAt": "2022-09-09T19:40:13Z",
        "channelId": "UCIOE_IzglfnHyaOYbvpJxjA",
        "title": "How to Beat the WET BANDITS in HOME ALONE",
        "description": "Get 10% off Gamer Supps using code: UNBEATEN https://gamersupps.gg/UNBEATEN If you had no other choice but to use ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Xp1rzNbPUK8/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Xp1rzNbPUK8/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Xp1rzNbPUK8/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Nerd Explains",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T19:40:13Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "K662PZ5l4rg"
      },
      "snippet": {
        "publishedAt": "2022-09-09T19:30:01Z",
        "channelId": "UCTscjwyiofdJFPwJG6359OA",
        "title": "Winter Rye Cover Crop for the Home Garden",
        "description": "Winter Rye is an excellent cover crop for use in the home garden. Check out Lomi here: ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/K662PZ5l4rg/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/K662PZ5l4rg/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/K662PZ5l4rg/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Growfully with Jenna",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T19:30:01Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "1SpbaRymjSg"
      },
      "snippet": {
        "publishedAt": "2022-09-09T19:04:21Z",
        "channelId": "UCvxAbvIxjv8xZycAWEygnjg",
        "title": "Home Tour at Hillman Dr (Jacksonville Heights Area)",
        "description": "If you have any questions about this house or interested to see other homes in Jacksonville, Florida, you can reach me directly ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/1SpbaRymjSg/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/1SpbaRymjSg/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/1SpbaRymjSg/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Philip Johnson",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T19:04:21Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "V6M4djdnS4c"
      },
      "snippet": {
        "publishedAt": "2022-09-09T18:31:42Z",
        "channelId": "UCwC5KjERcAYHBxrDs47KBMg",
        "title": "Check out our Modern Custom Model Home! (1 BR / 1 BA | 800 Sq. Ft.) - The Ruston",
        "description": "https://timberland-homes.com/the-ruston-model-home/ The Ruston features a contemporary design to connect the light and airy ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/V6M4djdnS4c/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/V6M4djdnS4c/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/V6M4djdnS4c/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Timberland Homes",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T18:31:42Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "ftDMVma9odE"
      },
      "snippet": {
        "publishedAt": "2022-09-09T18:05:45Z",
        "channelId": "UClMs26ViHFMy7MS897Alcxw",
        "title": "Ryan Kelley the Home Loan Expert",
        "description": "Get an education from Ryan Kelley the Home Loan Expert.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/ftDMVma9odE/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/ftDMVma9odE/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/ftDMVma9odE/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "FOX 2 St. Louis",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T18:05:45Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "ymvUZUoQjww"
      },
      "snippet": {
        "publishedAt": "2022-09-09T18:02:59Z",
        "channelId": "UC-OLruU3dJkvVfiLXjXLJTg",
        "title": "Zbulohet kandidati i nëntë i shtëpisë &quot;It&#39;s My Home&quot;",
        "description": "www.facebook.com/firstchannel www.facebook.com/valamala.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/ymvUZUoQjww/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/ymvUZUoQjww/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/ymvUZUoQjww/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "First Channel",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T18:02:59Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "Vo2kWQzfPPk"
      },
      "snippet": {
        "publishedAt": "2022-09-09T18:00:18Z",
        "channelId": "UCWYs4KqAdayj6oTAYVKDplg",
        "title": "Home Prices See Largest Drop In 11 Years",
        "description": "If you're looking for news that will make your day, then check out our latest article on home prices! In the past year, home prices ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Vo2kWQzfPPk/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Vo2kWQzfPPk/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Vo2kWQzfPPk/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Real Estate Ninja",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T18:00:18Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "mSiTOs7qZN4"
      },
      "snippet": {
        "publishedAt": "2022-09-09T18:00:18Z",
        "channelId": "UCYs1kDYvE7KVlJOCtqhnC-w",
        "title": "Old School GOODWILL THRIFT WITH ME Vlog + HOME DECOR THRIFT HAUL  + FLEA MARKET HAUL",
        "description": "On my channel I love to share thrifting style videos which include Thrift Hauls and Thrift With Me videos. I thrift at a lot of different ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/mSiTOs7qZN4/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/mSiTOs7qZN4/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/mSiTOs7qZN4/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Bored or Bananas",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T18:00:18Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "Ujy-RHtJM9g"
      },
      "snippet": {
        "publishedAt": "2022-09-09T17:05:17Z",
        "channelId": "UCsq-YuzAeCHxa091J_yAZDQ",
        "title": "Guys On The Way Home Walking From Work",
        "description": "Join this channel to get access to perks: https://www.youtube.com/channel/UCsq-YuzAeCHxa091J_yAZDQ/join #yoga ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Ujy-RHtJM9g/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Ujy-RHtJM9g/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Ujy-RHtJM9g/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Nikky's Official",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T17:05:17Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "3uq4KNPpKxg"
      },
      "snippet": {
        "publishedAt": "2022-09-09T17:00:03Z",
        "channelId": "UCDNqG34yDOMvLkFl8MmaHgA",
        "title": "$25k Solar Tiny Home!!! Offer Ends October 31st 🏡🇺🇸🤗😉🚚🔋",
        "description": "https://www.incredibletinyhomes.com.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/3uq4KNPpKxg/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/3uq4KNPpKxg/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/3uq4KNPpKxg/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Incredible Tiny Homes",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T17:00:03Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "NqtpDykbk6g"
      },
      "snippet": {
        "publishedAt": "2022-09-09T17:00:21Z",
        "channelId": "UCAzmPUFeVdlgNEA8Hfkcmpw",
        "title": "Halloween Shopping at Home Depot, Walmart &amp; Lowes",
        "description": "I went out to Walmart, Lowes & The Home Depot to see what fun Halloween decorations they had. I saw a lot of cool stuff and ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/NqtpDykbk6g/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/NqtpDykbk6g/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/NqtpDykbk6g/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "OGP",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T17:00:21Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "KS-p5CS_Sxk"
      },
      "snippet": {
        "publishedAt": "2022-09-09T17:00:23Z",
        "channelId": "UCzdrAXr2POl0JzbBCLxzTmg",
        "title": "Spider-Man PC - Spider-Verse Co-op Gameplay | No Way Home Mods Concept",
        "description": "In this video, you will see the famous Spidey trio from Spider-Man: No Way Home swing TOGETHER around NYC in various ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/KS-p5CS_Sxk/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/KS-p5CS_Sxk/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/KS-p5CS_Sxk/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "ItIsSpid",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T17:00:23Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "u6YhD83jTjU"
      },
      "snippet": {
        "publishedAt": "2022-09-09T16:52:44Z",
        "channelId": "UCck6Ng7xcW_m9rxgvhVvjpw",
        "title": "Neymar MAGICAL vs. Juventus | UCL Home 2022 HD 1080i",
        "description": "Neymar MAGICAL vs. Juventus | UCL Home 2022 HD 1080i Make sure to subscribe & turn the post notifications on!",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/u6YhD83jTjU/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/u6YhD83jTjU/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/u6YhD83jTjU/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Bilal Prods",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T16:52:44Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "alnP1U2RFkc"
      },
      "snippet": {
        "publishedAt": "2022-09-09T16:30:11Z",
        "channelId": "UCuyUQYlWnnqU0OXYMgg9VXw",
        "title": "HONEY PURITY TEST AT HOME Kannada || ignis fitness || Kannada",
        "description": "honey #puritytest #easytestforhoney click the below link to watch my other youtube channel videos RAMESH MOTO VLOGS ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/alnP1U2RFkc/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/alnP1U2RFkc/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/alnP1U2RFkc/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Ignis Fitness",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T16:30:11Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#channel",
        "channelId": "UCB0BkuFEZk2AECJIDhiBxug"
      },
      "snippet": {
        "publishedAt": "2022-09-09T16:02:57Z",
        "channelId": "UCB0BkuFEZk2AECJIDhiBxug",
        "title": "Feels Like Home",
        "description": "",
        "thumbnails": {
          "default": {
            "url": "https://yt3.ggpht.com/uCL-iW0mUqeoXUaCKtw7d5P7lzt3o-9sJgyZJnZhw1Z5qu83U2cMvxMrSFephx0LquBylf00WQ=s88-c-k-c0xffffffff-no-rj-mo"
          },
          "medium": {
            "url": "https://yt3.ggpht.com/uCL-iW0mUqeoXUaCKtw7d5P7lzt3o-9sJgyZJnZhw1Z5qu83U2cMvxMrSFephx0LquBylf00WQ=s240-c-k-c0xffffffff-no-rj-mo"
          },
          "high": {
            "url": "https://yt3.ggpht.com/uCL-iW0mUqeoXUaCKtw7d5P7lzt3o-9sJgyZJnZhw1Z5qu83U2cMvxMrSFephx0LquBylf00WQ=s800-c-k-c0xffffffff-no-rj-mo"
          }
        },
        "channelTitle": "Feels Like Home",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T16:02:57Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "zOLJrkn4zpY"
      },
      "snippet": {
        "publishedAt": "2022-09-09T15:00:11Z",
        "channelId": "UCmKm7HJdOfkWLyml-fzKlVg",
        "title": "DubVision &amp; Afrojack - Feels Like Home (Official Song F1 Dutch Grand Prix) (Official Video)",
        "description": "DubVision & Afrojack - Feels Like Home is OUT NOW! Download/Stream here: https://dubvisionafrojack.lnk.to/FeelsLikeHome ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/zOLJrkn4zpY/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/zOLJrkn4zpY/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/zOLJrkn4zpY/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Afrojack",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T15:00:11Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "Q0VXgEMwYWM"
      },
      "snippet": {
        "publishedAt": "2022-09-09T14:30:09Z",
        "channelId": "UCs90hFxbwOTpg88obm2UNWw",
        "title": "Amazing Hand making flower design trick.Easy Hand making Flower idea: Home Decoration",
        "description": "Amazing Hand Embroidery flower design trick with Very Easy Hand Embroidery flower design ideaAmazing Hand Embroidery ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Q0VXgEMwYWM/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Q0VXgEMwYWM/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Q0VXgEMwYWM/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Fashion Designer",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T14:30:09Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "nicf760n2Iw"
      },
      "snippet": {
        "publishedAt": "2022-09-09T14:00:33Z",
        "channelId": "UCwjBwP7WI_ZVUnOWTpY2HmQ",
        "title": "Neuanfang nach Todgeburt! | Teil 1 | Zuhause im Glück | RTLZWEI Home",
        "description": "Die dramatische Geburt ihres Sohnes Lewin wirft Denise und Björn völlig aus der Bahn. Das Kleinkind ist schwerst ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/nicf760n2Iw/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/nicf760n2Iw/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/nicf760n2Iw/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "RTLZWEI Home",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T14:00:33Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "KPXiG6bRu2M"
      },
      "snippet": {
        "publishedAt": "2022-09-09T14:00:10Z",
        "channelId": "UCzQjAS-L_m4S1tWp6ea7jZg",
        "title": "🍁NEW FALL HOME TOUR 2022 -🍂 MUST SEE! 🍁 VINTAGE + COTTAGE + FARMHOUSE DECOR",
        "description": "Welcome to YoUniquely Vintage You. We are so thankful that each and everyone of you are here. For our last video we shared my ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/KPXiG6bRu2M/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/KPXiG6bRu2M/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/KPXiG6bRu2M/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "YoUniquely Vintage You - Michele Deaton",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T14:00:10Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "V8ABups0Y30"
      },
      "snippet": {
        "publishedAt": "2022-09-09T13:46:50Z",
        "channelId": "UCwjf_c0d84mPBcFbDyyDHsw",
        "title": "Spider Man Home Coming vs Spider Man No Way Home, Spider Man Miles Morales Funny - Nick Funeral...!",
        "description": "Spider Man Home Coming vs Spider Man No Way Home, Spider Man Miles Morales Funny - Nick Funeral...! Subscribe us on ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/V8ABups0Y30/default_live.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/V8ABups0Y30/mqdefault_live.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/V8ABups0Y30/hqdefault_live.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Awesome Toon",
        "liveBroadcastContent": "live",
        "publishTime": "2022-09-09T13:46:50Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "gAhVWSZ9NHQ"
      },
      "snippet": {
        "publishedAt": "2022-09-09T13:29:14Z",
        "channelId": "UCjEBl91D0HkcOD6hIAvCzGw",
        "title": "Walk You Home - NCT Dream - 220909 The Dream Show 2 Jamsil Olympic Stadium, Seoul",
        "description": "Buat nyimpen aja.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/gAhVWSZ9NHQ/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/gAhVWSZ9NHQ/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/gAhVWSZ9NHQ/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Falihah Balqis",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T13:29:14Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "o3AqTLBBeAU"
      },
      "snippet": {
        "publishedAt": "2022-09-09T13:00:10Z",
        "channelId": "UC-fdlVb0I62r597hKtiH0qw",
        "title": "MOBLIE HOME CLEANING/ CLEAN WITH ME",
        "description": "Hey yall. I have been sick so this is a quick little clean up the house. I have a cold and I felt terrible but I did get a lot done. I hope ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/o3AqTLBBeAU/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/o3AqTLBBeAU/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/o3AqTLBBeAU/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Living with Lynn",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T13:00:10Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "xXl0ynhazZs"
      },
      "snippet": {
        "publishedAt": "2022-09-09T12:56:10Z",
        "channelId": "UCd7am4s4VZdy8KxGbyUSM3w",
        "title": "DIY | macrame wall hanging handmade home decor interior design | 마크라메 월 행잉 핸드메이드 집 꾸미기 인테리어 소품",
        "description": "How to make a macrame wall hanging using basic knot   I made a macrame layered wall hanging using basic knots. Let's make it ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/xXl0ynhazZs/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/xXl0ynhazZs/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/xXl0ynhazZs/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "LET BE 렛비",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T12:56:10Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "R7mGPy1aqtc"
      },
      "snippet": {
        "publishedAt": "2022-09-09T12:28:15Z",
        "channelId": "UCiExigMIqRfZL6s3fwfYMLQ",
        "title": "N U Home",
        "description": "Provided to YouTube by Routenote N U Home · US Golf 95 Metro City ℗ Jordan Sexton Released on: 2022-08-03 Auto-generated ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/R7mGPy1aqtc/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/R7mGPy1aqtc/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/R7mGPy1aqtc/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "US Golf 95 - Topic",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T12:28:15Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "GVhWOwfmfzo"
      },
      "snippet": {
        "publishedAt": "2022-09-09T12:27:21Z",
        "channelId": "UCCYo_RKhJNzlYxuhZPQMcMg",
        "title": "Spider-Man Home Coming vs Spider-Man No Way Home, Spider-Man Miles Funny Cartoon | VFX Technology",
        "description": "Spider-Man Home Coming vs Spider-Man No Way Home, Spider-Man Miles Funny Cartoon | VFX Technology #comosix ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/GVhWOwfmfzo/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/GVhWOwfmfzo/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/GVhWOwfmfzo/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "VFX Technology",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T12:27:21Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#channel",
        "channelId": "UCY0LyJAp56NowWyxnTQx9xQ"
      },
      "snippet": {
        "publishedAt": "2022-09-09T12:20:04Z",
        "channelId": "UCY0LyJAp56NowWyxnTQx9xQ",
        "title": "Take Me Home",
        "description": "",
        "thumbnails": {
          "default": {
            "url": "https://yt3.ggpht.com/ytJ34T_yTwVlHpDNdD3d2K32e7QaptlpCkv3ALKiwgGw9AB6T9Dl4TX7ObHNmD0-dFZA9VqLcQ=s88-c-k-c0xffffffff-no-rj-mo"
          },
          "medium": {
            "url": "https://yt3.ggpht.com/ytJ34T_yTwVlHpDNdD3d2K32e7QaptlpCkv3ALKiwgGw9AB6T9Dl4TX7ObHNmD0-dFZA9VqLcQ=s240-c-k-c0xffffffff-no-rj-mo"
          },
          "high": {
            "url": "https://yt3.ggpht.com/ytJ34T_yTwVlHpDNdD3d2K32e7QaptlpCkv3ALKiwgGw9AB6T9Dl4TX7ObHNmD0-dFZA9VqLcQ=s800-c-k-c0xffffffff-no-rj-mo"
          }
        },
        "channelTitle": "Take Me Home",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T12:20:04Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "VEd3SB9tKVA"
      },
      "snippet": {
        "publishedAt": "2022-09-09T11:25:51Z",
        "channelId": "UC989FcfVX6oe18h23ZYVp4w",
        "title": "HOME TOUR della mia casa a DUBAI 🏙️",
        "description": "Dopo innumerevoli richieste e ormai un po' all'ultimo, vi faccio fare l'home tour della mia casa a dubai! Dal 2014 al 2018 ho girato ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/VEd3SB9tKVA/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/VEd3SB9tKVA/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/VEd3SB9tKVA/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Marianna in Dubai",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T11:25:51Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "CZRysHtACI4"
      },
      "snippet": {
        "publishedAt": "2022-09-09T11:00:07Z",
        "channelId": "UC2NKV6ynIgxExjdPfS_zgKg",
        "title": "HOME TOUR 🏡 La nostra casetta a Milano!!",
        "description": "Ciao ragazzi!! Finalmente dopo 6 mesi a Milano vi mostro la nostra casetta. Sono super felice di com'è e la trovo perfetta per noi ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/CZRysHtACI4/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/CZRysHtACI4/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/CZRysHtACI4/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Carolina Chiari",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T11:00:07Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "zyWN963087o"
      },
      "snippet": {
        "publishedAt": "2022-09-09T10:02:27Z",
        "channelId": "UCvxv6MrN3IyE8_SgpwK3iqw",
        "title": "Home",
        "description": "Provided to YouTube by CDBaby Home · Mockingbird Band Mockingbird ℗ 2022 Mockingbird Band Released on: 2022-09-10 ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/zyWN963087o/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/zyWN963087o/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/zyWN963087o/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Various Artists - Topic",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T10:02:27Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "PpBevYmgBcc"
      },
      "snippet": {
        "publishedAt": "2022-09-09T10:00:13Z",
        "channelId": "UCjMy7jt0wzQYLjuwxkgv2bw",
        "title": "ประวัติตัวละคร ยายคำ [Granny Kham] | Home Sweet Home Survive",
        "description": "ฉบับเต็ม : https://www.youtube.com/watch?v=Kab2nRfRWzA สมัครเป็นสมาชิกของช่องนี้เพื่อเข้าถึงสิทธิพิเศษต่างๆ ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/PpBevYmgBcc/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/PpBevYmgBcc/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/PpBevYmgBcc/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "DuDee",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T10:00:13Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "7l7xLs9uK-I"
      },
      "snippet": {
        "publishedAt": "2022-09-09T08:35:00Z",
        "channelId": "UCJ0uqCI0Vqr2Rrt1HseGirg",
        "title": "Kris Jenner Reorganizes Kylie&#39;s House When She&#39;s Not Home",
        "description": "James's guests Kylie Jenner and Kris Jenner join him on the couch, and they celebrate the fact that Kylie is here even though she ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/7l7xLs9uK-I/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/7l7xLs9uK-I/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/7l7xLs9uK-I/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "The Late Late Show with James Corden",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T08:35:00Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "08yTHYvCg2o"
      },
      "snippet": {
        "publishedAt": "2022-09-09T08:29:18Z",
        "channelId": "UCJtS_7gQr-mpwDvmPODptPg",
        "title": "Spider Man Home Coming vs Spider Man No Way Home, Spider Man Miles Morales Funny Cartoon",
        "description": "Spider Man Home Coming vs Spider Man No Way Home, Spider Man Miles Morales Funny Cartoon.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/08yTHYvCg2o/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/08yTHYvCg2o/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/08yTHYvCg2o/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Among Us",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T08:29:18Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "fBcC0iQgkpU"
      },
      "snippet": {
        "publishedAt": "2022-09-09T08:00:12Z",
        "channelId": "UCfcNv8ouORZpmmRe5VCDqUg",
        "title": "Spider Man Home Coming vs Spider Man No Way Home, Spider Man Miles Morales With Wild Animals Game",
        "description": "Spider Man Home Coming vs Spider Man No Way Home, Spider Man Miles Morales With Wild Animals Game ⚡️ YouTube ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/fBcC0iQgkpU/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/fBcC0iQgkpU/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/fBcC0iQgkpU/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Animal World",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T08:00:12Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "RtGIDoNcyz4"
      },
      "snippet": {
        "publishedAt": "2022-09-09T07:30:04Z",
        "channelId": "UCU6HkRQLLod0IsjKy0Ausgw",
        "title": "Earn 100000/- p/m| Lifetime Earn With Studypool Work From Home Jobs| Typing Work| Form filling Work|",
        "description": "Join this channel to get access to perks: https://www.youtube.com/channel/UCU6HkRQLLod0IsjKy0Ausgw/join Dosto aap bhi es ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/RtGIDoNcyz4/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/RtGIDoNcyz4/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/RtGIDoNcyz4/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Job Seekers",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T07:30:04Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "SDzfUval-CY"
      },
      "snippet": {
        "publishedAt": "2022-09-09T05:18:56Z",
        "channelId": "UC0VhKZDq2BVzFZOXe7o98dQ",
        "title": "Modern and beautiful 🌹home elevation design 🎉🙀DK 3D HOME DESIGN",
        "description": "",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/SDzfUval-CY/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/SDzfUval-CY/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/SDzfUval-CY/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "D K 3D HOME DESIGN",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T05:18:56Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "Z7GblT445BE"
      },
      "snippet": {
        "publishedAt": "2022-09-09T05:00:39Z",
        "channelId": "UCVWQWc8PXy6Itt7YNrivOYw",
        "title": "Young mother beheaded in front of her San Carlos home",
        "description": "KRON4's Dan Thorn reports.",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Z7GblT445BE/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Z7GblT445BE/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Z7GblT445BE/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "KRON 4",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T05:00:39Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "uYtMpAk4-28"
      },
      "snippet": {
        "publishedAt": "2022-09-09T05:00:54Z",
        "channelId": "UCeuXd6PLk_t2WGIhPMvkUSA",
        "title": "Tool Items!😍New Gadgets, Smart Appliances, Kitchen Utensils/Home Cleaning/Beauty, Inventions #shorts",
        "description": "",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/uYtMpAk4-28/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/uYtMpAk4-28/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/uYtMpAk4-28/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Tool Items",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T05:00:54Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "bzhNwVkXHlg"
      },
      "snippet": {
        "publishedAt": "2022-09-09T04:30:09Z",
        "channelId": "UC-i6eotFMKFK2lSkKpqZwqw",
        "title": "😍Smart Appliances, New Gadgets For Every Home/ Versatile Utensils(Inventions &amp; Ideas)/MakeupKitchen",
        "description": "Smart Appliances, New Gadgets For Every Home/ Versatile Utensils(Inventions & Ideas)/ MakeupKitchen FOLLOW US, ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/bzhNwVkXHlg/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/bzhNwVkXHlg/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/bzhNwVkXHlg/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "ArtKo Point",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T04:30:09Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "BnYhNgy7sQA"
      },
      "snippet": {
        "publishedAt": "2022-09-09T04:10:58Z",
        "channelId": "UCOw3uyJI7GgSSJWXDKh2azA",
        "title": "Permanent Work from Home jobs | Microsoft Work from Home job|Latest jobs 2022 in Telugu|V the Techee",
        "description": "Microsoft Work from Home Job(Remote Data Center Technician) Apply Link: ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/BnYhNgy7sQA/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/BnYhNgy7sQA/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/BnYhNgy7sQA/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "V the Techee",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T04:10:58Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "Bd0npJvdrMU"
      },
      "snippet": {
        "publishedAt": "2022-09-09T03:15:11Z",
        "channelId": "UCfxV3f4XXX_GP2Wm9Z-1B_g",
        "title": "Devin Bush Showing Off In Home Opener | Madden 23 Steelers All Madden Franchise Rebuild Ep.4",
        "description": "madden23gameplay #franchisemode #steelers Welcome the Steelers Franchise in Madden NFL 23. This series will be like no ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/Bd0npJvdrMU/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/Bd0npJvdrMU/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/Bd0npJvdrMU/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "SimFBallCritic",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T03:15:11Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "rASfiErkzkA"
      },
      "snippet": {
        "publishedAt": "2022-09-09T02:53:58Z",
        "channelId": "UCgNIbmuzWllNcq4EdbDgJ9Q",
        "title": "Returning home",
        "description": "Provided to YouTube by Revelator Ltd. Returning home · Christopher Feil Returning home ℗ 2022 Utensils Smart Home ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/rASfiErkzkA/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/rASfiErkzkA/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/rASfiErkzkA/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Various Artists - Topic",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T02:53:58Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "GErquY9KYkI"
      },
      "snippet": {
        "publishedAt": "2022-09-09T01:57:07Z",
        "channelId": "UCdrWJO8JIeCgacnZhoKYcgg",
        "title": "Your Home Is Your Home",
        "description": "Provided to YouTube by Awal Digital Ltd Your Home Is Your Home · Damian Tanner Your Home Is Your Home ℗ Damian Tanner ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/GErquY9KYkI/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/GErquY9KYkI/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/GErquY9KYkI/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "Damian Tanner - Topic",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T01:57:07Z"
      }
    },
    {
      "kind": "youtube#searchResult",
      "id": {
        "kind": "youtube#video",
        "videoId": "c0wZM6WGUJc"
      },
      "snippet": {
        "publishedAt": "2022-09-09T01:39:01Z",
        "channelId": "UCcC-zNdZicVViZfgs7nonvw",
        "title": "Carlos Correa Hits GO-AHEAD Home Run vs. Yankees!",
        "description": "Yankees nemesis Carlos Correa hits a clutch, go-ahead home run in the 8th to give the Twins a 4-2 lead. Use Promo Code ...",
        "thumbnails": {
          "default": {
            "url": "https://i.ytimg.com/vi/c0wZM6WGUJc/default.jpg",
            "width": 120,
            "height": 90
          },
          "medium": {
            "url": "https://i.ytimg.com/vi/c0wZM6WGUJc/mqdefault.jpg",
            "width": 320,
            "height": 180
          },
          "high": {
            "url": "https://i.ytimg.com/vi/c0wZM6WGUJc/hqdefault.jpg",
            "width": 480,
            "height": 360
          }
        },
        "channelTitle": "TrueRGM: Player Highlights",
        "liveBroadcastContent": "none",
        "publishTime": "2022-09-09T01:39:01Z"
      }
    }
  ]